import { Icon, IconProps } from "./Icon";

export function IconSunny(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M11.5 0h1v3.99h-1V0Zm0 19.99h1V24h-1v-4.01Zm8.49-8.49H24v1h-4.01v-1ZM0 11.5h4.01v1H0v-1Zm17.26-5.47 2.87-2.87.71.7-2.87 2.88-.7-.7Zm-14.1 14.1 2.87-2.87.71.7-2.87 2.88-.7-.7Zm14.1-2.16.7-.7 2.88 2.86-.7.7-2.88-2.86ZM3.16 3.87l.7-.7 2.88 2.86-.7.7-2.88-2.86ZM12 5a7 7 0 1 0 0 14 7 7 0 0 0 0-14m0 13a6 6 0 1 1 0-12 6 6 0 0 1 0 12"
      />
    </Icon>
  );
}
